import { render, staticRenderFns } from "./hitchManage.vue?vue&type=template&id=a0b56e6a&scoped=true&"
import script from "./hitchManage.vue?vue&type=script&lang=js&"
export * from "./hitchManage.vue?vue&type=script&lang=js&"
import style0 from "./hitchManage.vue?vue&type=style&index=0&id=a0b56e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b56e6a",
  null
  
)

export default component.exports